<template>
  <!-- <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div> -->
  <form @submit.prevent="handleFilters">
    <div class="row filter-row mb-3">
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Job Title</label>
            <i
              v-if="filters.job_title"
              @click="handleClearOneFilter('job_title')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :options="jobs"
            v-model="filters.job_title"
            placeholder="Select Job Title"
            id="design3"
          />
        </div>
      </div>
      <div class="col-sm-6 col-md-2">
        <div class="input-block mt-1 mb-0">
          <div class="filter-label-row">
            <label class="filter-label">Status</label>
            <i
              v-if="filters.referral_status"
              @click="handleClearOneFilter('referral_status')"
              class="fa-solid fa-x filter-clear-icon"
            ></i>
          </div>
          <vue-select
            :options="employmentStatuses"
            placeholder="Select Status"
            id="design"
            v-model="filters.referral_status"
          />
        </div>
      </div>

      <!-- <div class="col-md-9"></div> -->
      <div class="d-flex align-items-end col-sm-6 col-md-3 gap-2 mt-1">
        <button
          type="submit"
          class="btn btn-filter"
          @click.prevent="handleFilters"
        >
          <i class="fa-solid fa-filter me-1"></i> Search
        </button>
        <button
          type="button"
          class="btn btn-reset"
          @click.prevent="resetAllFilters"
        >
          <i class="fa-solid fa-rotate-left me-1"></i> Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import RecruitmentRequisitionService from "@/services/RecruitmentRequisitionService";

export default {
  data() {
    return {
      select2: null,
      isFocused: false,
      filters: {
        referral_status: "",
        job_title: "",
      },

      isFocusedOn: false,
      employmentStatuses: [
        "done_interview",
        "cancel_interview",
        "scheduled_interview",
        "hire_candidate",
        "reject_candidate",
        "on_hold",
        "blacklist",
      ].map((el) => { return {id: el, text: el.replace(/_/g, ' ')}}),
      jobs: [],
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters(value) {
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit("apply-filters", this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;
      if (this.searched) {
        this.$emit("apply-filters", this.filters);
      }
      if (!filtersHasProperty) {
        this.searched = false;
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    async fetchJobs() {
      try {
        const response = await RecruitmentRequisitionService.fetch();
        this.jobs = response?.data
          .filter((el) => el.status == "publish")
          .map((e) => e.job_title);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        referral_status: "",
        job_title: "",
      };
      this.searched = false;
    },
    async fetchServices() {
      try {
        this.fetchJobs();
      } catch (error) {
        console.log("error fetching services", error);
      }
    },
  },
  created() {
    this.searched = false;
    this.fetchServices();
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>

<style scoped>
.filter-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.filter-label {
  font-size: 12.5px;
  font-weight: 600;
  color: #878787;
  margin: 0 0 4px;
  padding: 0;
}

.filter-label-row .filter-label {
  margin: 0;
}

.filter-clear-icon {
  font-size: 10px;
  color: #8c9bb5;
  cursor: pointer;
  transition: color 0.2s ease;
}

.filter-clear-icon:hover {
  color: var(--primary-color);
}

:deep(.select2-container--default .select2-selection--single) {
  height: 36px !important;
  border-radius: 6px !important;
  border: 1px solid #dcdfe6 !important;
  transition: all 0.2s ease;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__rendered) {
  font-size: 12.5px !important;
  line-height: 34px !important;
  padding-left: 12px !important;
  padding-right: 30px !important;
}

:deep(.select2-container--default .select2-selection--single .select2-selection__arrow) {
  height: 34px !important;
}

:deep(.select2-container--open .select2-selection--single) {
  border-color: var(--primary-color) !important;
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--primary-color) 10%, transparent);
}

.btn-filter {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: var(--primary-color);
  border: 1px solid var(--primary-color);
  color: #ffffff;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-filter:hover {
  background-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  border-color: color-mix(in srgb, var(--primary-color) 90%, #000);
  color: #ffffff;
}

.btn-reset {
  height: 36px;
  padding: 0 14px;
  font-size: 12.5px;
  font-weight: 700;
  border-radius: 6px;
  background-color: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
  transition: all 0.2s ease;
  cursor: pointer;
}

.btn-reset:hover {
  background-color: #f5f7fa;
  border-color: #c0c4cc;
  color: #303133;
}
</style>
